import { defineStyleConfig } from '@chakra-ui/react'

export const badgeTheme = defineStyleConfig({
  baseStyle: {
    fontSize: '0.65rem',
    rounded: 'md'
    // px: 2
  }
})
